import React, { Fragment, useState } from "react";
import { Row, Col, Button, Card, Collapse, } from "react-bootstrap";
import Physician from "../Physician/Models/Physician";
import { getDateWithOffset } from "../Shared/Utility/GetDateWithOffset";

interface IProps {
    isSectionOpen: boolean;
    physicianId: number;
    physician: Physician;
}

export default function PersonalCard(props: IProps) {
    const [openCollapse, setOpenCollapse] = useState<boolean>(props.isSectionOpen);
    const currentName = props.physician.fullName;
    const dateOfBirth = getDateWithOffset(props.physician.dateOfBirth).toLocaleDateString();
    const ssn4 = props.physician.ssn4;
    const instructionsUrl = 'https://www.abpn.org/wp-content/uploads/2015/05/ABPN_Name_DOB_SSN_Change_Instructions.pdf';

    const openInstructions = () => {
        window.open(instructionsUrl, '_blank').focus();
    }

    let viewInstructionsButton = <Button className="font-weight-bold" variant="pp-primary" onClick={openInstructions}>
        View Change Instructions <i className="las la-external-link-alt"></i>
    </Button>

    return (
        <Card border="pp-secondary-grey">
            <Card.Body>
                <Card.Title className="font-weight-bolder" onClick={() => setOpenCollapse(!openCollapse)}>
                    <span className="text-pp-primary"><i className="font-weight-bolder las la-angle-down"></i> Personal</span>
                </Card.Title>
                <Collapse in={openCollapse}>
                    <Row>
                        <Col xs={12} md={4} className="px-2">
                            <Card className="mb-3">
                                <Card.Body>
                                    <Card.Title className="font-weight-bold">Name</Card.Title>
                                    <Fragment>
                                        <Card.Text className="pp-font-size-smaller">{currentName}</Card.Text>
                                        {viewInstructionsButton}
                                    </Fragment>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} className="px-2">
                            <Card className="mb-3">
                                <Card.Body>
                                    <Card.Title className="font-weight-bold">Date of Birth</Card.Title>
                                    <Fragment>
                                        <Card.Text className="pp-font-size-smaller">{dateOfBirth}</Card.Text>
                                        {viewInstructionsButton}
                                    </Fragment>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} className="px-2">
                            <Card className="mb-3">
                                <Card.Body>
                                    <Card.Title className="font-weight-bold">Last 4 of SSN</Card.Title>
                                    <Fragment>
                                        <Card.Text className="pp-font-size-smaller">{ssn4}</Card.Text>
                                        {viewInstructionsButton}
                                    </Fragment>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Collapse>
            </Card.Body>
        </Card>
    );
}